import { TipoParentescoEnum } from "src/app/core/enums/tipo-parentesco.enum";
import { ListaTipoIdentificacion } from "../model/tipo-identificacion.enum";
import { Injectable } from "@angular/core";
import { WresponseData } from "src/app/core/models/worker/wresponse-data";

@Injectable({
  providedIn: "root",
})
export class ValidacionesFechaNacimientoService {
  private edadMinimaParaTenerHijos: number = 12;

  private fechaActual: Date = null;
  private edadAfiliado: number = null;
  private fechaNacimientoAfiliado: Date = null;
  private tieneDiscapacidad: string = null;

  constructor() {}

  /**
   * Función para obtener la fecha inicial (desde) y la la fecha final (hasta) para utilizar en el campo fecha de nacimiento
   * @param informacionTrabajador información del afiliado
   * @param tipoParentesco parentesco del beneficiario
   * @param tipoIdentificacion tipo de documento del beneficiario
   * @param tieneDiscapacidad string de true o false para conocer si tiene discapacidad el beneficiario
   */
  reglasSegunParentescoYDocumentoDeIndentificacion(
    informacionTrabajador: WresponseData,
    tipoParentesco: string,
    tipoIdentificacion: string,
    tieneDiscapacidad: string
  ) {
    this.edadAfiliado = parseInt(
      informacionTrabajador.validacion_afiliado.afiliado.edad
    );
    this.fechaNacimientoAfiliado = new Date(
      informacionTrabajador.validacion_afiliado.afiliado.fechaNacimiento
    );
    this.tieneDiscapacidad = tieneDiscapacidad;

    const data = {
      [TipoParentescoEnum.HIJO]: {
        [ListaTipoIdentificacion.CC.codigo]:
          this.calcularRangoFechaNacimiento_validandoHijo(23, 18),
        [ListaTipoIdentificacion.RC.codigo]:
          this.calcularRangoFechaNacimiento_menoresDeEdad(7, 0),
        [ListaTipoIdentificacion.CE.codigo]:
        this.calcularRangoFechaNacimiento_validandoHijo(23, 7),
        [ListaTipoIdentificacion.TI.codigo]:
          this.calcularRangoFechaNacimiento_menoresDeEdad(18, 7),
        [ListaTipoIdentificacion.PA.codigo]:
          this.calcularRangoFechaNacimiento_menoresDeEdad2(7, 0),
        [ListaTipoIdentificacion.PEP.codigo]:
          this.calcularRangoFechaNacimiento_validandoHijo(23, 18),
        [ListaTipoIdentificacion.PPT.codigo]:
          this.calcularRangoFechaNacimiento_menoresDeEdad(23, 0),
        [ListaTipoIdentificacion.CD.codigo]:
          this.calcularRangoFechaNacimiento_validandoHijo(23, 18),
      },
      [TipoParentescoEnum.HIJASTRO]: {
        [ListaTipoIdentificacion.CC.codigo]:
          this.calcularRangoFechaNacimiento_validandoDiscapacidad(23, 18),
        [ListaTipoIdentificacion.RC.codigo]:
          this.calcularRangoFechaNacimiento_menoresDeEdad(7, 0),
        [ListaTipoIdentificacion.CE.codigo]:
          this.calcularRangoFechaNacimiento_validandoHijo(23, 7),
        [ListaTipoIdentificacion.TI.codigo]:
          this.calcularRangoFechaNacimiento_menoresDeEdad(18, 7),
        [ListaTipoIdentificacion.PA.codigo]:
          this.calcularRangoFechaNacimiento_validandoDiscapacidad(23, 18),
        [ListaTipoIdentificacion.PEP.codigo]:
          this.calcularRangoFechaNacimiento_validandoDiscapacidad(23, 18),
        [ListaTipoIdentificacion.PPT.codigo]:
          this.calcularRangoFechaNacimiento_menoresDeEdad(23, 0),
        [ListaTipoIdentificacion.CD.codigo]:
          this.calcularRangoFechaNacimiento_validandoDiscapacidad(23, 18),
      },
      [TipoParentescoEnum.PADRE]: {
        [ListaTipoIdentificacion.CC.codigo]:
          this.calcularRangoFechaNacimiento_padres(),
        [ListaTipoIdentificacion.CE.codigo]:
          this.calcularRangoFechaNacimiento_padres(),
        [ListaTipoIdentificacion.PA.codigo]:
          this.calcularRangoFechaNacimiento_padres(),
        [ListaTipoIdentificacion.PEP.codigo]:
          this.calcularRangoFechaNacimiento_padres(),
        [ListaTipoIdentificacion.PPT.codigo]:
          this.calcularRangoFechaNacimiento_padres(),
        [ListaTipoIdentificacion.CD.codigo]:
          this.calcularRangoFechaNacimiento_padres(),
      },
      [TipoParentescoEnum.MADRE]: {
        [ListaTipoIdentificacion.CC.codigo]:
          this.calcularRangoFechaNacimiento_padres(),
        [ListaTipoIdentificacion.CE.codigo]:
          this.calcularRangoFechaNacimiento_padres(),
        [ListaTipoIdentificacion.PA.codigo]:
          this.calcularRangoFechaNacimiento_padres(),
        [ListaTipoIdentificacion.PEP.codigo]:
          this.calcularRangoFechaNacimiento_padres(),
        [ListaTipoIdentificacion.PPT.codigo]:
          this.calcularRangoFechaNacimiento_padres(),
        [ListaTipoIdentificacion.CD.codigo]:
          this.calcularRangoFechaNacimiento_padres(),
      },
      [TipoParentescoEnum.HERMANO]: {
        [ListaTipoIdentificacion.CC.codigo]:
          this.calcularRangoFechaNacimiento_validandoDiscapacidad(23, 18),
        [ListaTipoIdentificacion.RC.codigo]:
          this.calcularRangoFechaNacimiento_menoresDeEdad(7, 0),
        [ListaTipoIdentificacion.CE.codigo]:
          this.calcularRangoFechaNacimiento_validandoHijo(23, 7),
        [ListaTipoIdentificacion.TI.codigo]:
          this.calcularRangoFechaNacimiento_menoresDeEdad(18, 7),
        [ListaTipoIdentificacion.PA.codigo]:
          this.calcularRangoFechaNacimiento_validandoDiscapacidad(23, 18),
        [ListaTipoIdentificacion.PEP.codigo]:
          this.calcularRangoFechaNacimiento_validandoDiscapacidad(23, 18),
        [ListaTipoIdentificacion.PPT.codigo]:
          this.calcularRangoFechaNacimiento_menoresDeEdad(23, 0),
        [ListaTipoIdentificacion.CD.codigo]:
          this.calcularRangoFechaNacimiento_validandoDiscapacidad(23, 18),
      },
      [TipoParentescoEnum.CONYUGE]: {
        [ListaTipoIdentificacion.CC.codigo]:
          this.calcularRangoFechaNacimiento_validandoDiscapacidad(100, 18),
        [ListaTipoIdentificacion.CE.codigo]:
          this.calcularRangoFechaNacimiento_validandoDiscapacidad(100, 18),
        [ListaTipoIdentificacion.PA.codigo]:
          this.calcularRangoFechaNacimiento_validandoDiscapacidad(100, 18),
        [ListaTipoIdentificacion.PEP.codigo]:
          this.calcularRangoFechaNacimiento_validandoDiscapacidad(100, 18),
        [ListaTipoIdentificacion.PPT.codigo]:
          this.calcularRangoFechaNacimiento_validandoDiscapacidad(100, 18),
        [ListaTipoIdentificacion.CD.codigo]:
          this.calcularRangoFechaNacimiento_validandoDiscapacidad(100, 18),
      },
    };

    return data[tipoParentesco][tipoIdentificacion];
  }

  private calcularRangoFechaNacimiento_menoresDeEdad(
    edadMaximaDelDocumento: number,
    edadMinimaDelDocumento: number
  ) {
    const anioMaximo =
      this.edadAfiliado - this.edadMinimaParaTenerHijos <=
      edadMaximaDelDocumento
        ? this.edadAfiliado - this.edadMinimaParaTenerHijos
        : edadMaximaDelDocumento;
    const anioMinimo = edadMinimaDelDocumento;

    this.fechaActual = new Date();

    return {
      fechaDesde: this.calcularFecha_desde(anioMaximo),
      fechaHasta: this.calcularFecha_hasta(anioMinimo),
    };
  }

  private calcularRangoFechaNacimiento_menoresDeEdad2(
    edadMaximaDelDocumento: number,
    edadMinimaDelDocumento: number
  ) {
    const anioMaximo =
      this.edadAfiliado - this.edadMinimaParaTenerHijos <=
      edadMaximaDelDocumento
        ? this.edadAfiliado - this.edadMinimaParaTenerHijos
        : edadMaximaDelDocumento;
    const anioMinimo = edadMinimaDelDocumento;

    this.fechaActual = new Date();

    return {
      fechaDesde: this.calcularFecha_desde2(anioMaximo),
      fechaHasta: this.calcularFecha_hasta(anioMinimo),
    };
  }

  private calcularRangoFechaNacimiento_padres() {
    const anioMaximo = 100;
    const anioMinimo = this.edadMinimaParaTenerHijos;

    this.fechaActual = this.fechaNacimientoAfiliado;

    return {
      fechaDesde: this.calcularFecha_desde(anioMaximo),
      fechaHasta: this.calcularFecha_hasta(anioMinimo),
    };
  }

  private calcularRangoFechaNacimiento_validandoHijo(
    edadMaximaDelDocumento: number,
    edadMinimaDelDocumento: number
  ) {
    let anioMaximo =
        this.edadAfiliado - this.edadMinimaParaTenerHijos <= edadMaximaDelDocumento
        ? this.edadAfiliado - this.edadMinimaParaTenerHijos
        : edadMaximaDelDocumento;

    this.tieneDiscapacidad === "true" ? anioMaximo = this.edadAfiliado - this.edadMinimaParaTenerHijos: null;
    const anioMinimo = edadMinimaDelDocumento;

    this.fechaActual = new Date();

    return {
      fechaDesde: this.calcularFecha_desdeV2(anioMaximo),
      fechaHasta: this.calcularFecha_hasta(anioMinimo),
    };
  }


  private calcularFecha_desdeV2(anioMinimoDocumento: number) {
    const diferenciaAnio = this.fechaActual.getFullYear() - anioMinimoDocumento;
    const mes = this.fechaNacimientoAfiliado.getMonth();
    let dia = this.fechaNacimientoAfiliado.getDate();

    // Se toma un dia antes en caso de que la fecha es bisiesto
    if (mes === 1 && dia === 29) {
      dia -= 1;
    }

    const date = new Date(diferenciaAnio, mes, dia);
    return date;
  }


  private calcularRangoFechaNacimiento_validandoDiscapacidad(
    edadMaximaDelDocumento: number,
    edadMinimaDelDocumento: number
  ) {
    const anioMaximo =
      this.tieneDiscapacidad === "true" ? 100 : edadMaximaDelDocumento;
    const anioMinimo = edadMinimaDelDocumento;

    this.fechaActual = new Date();

    return {
      fechaDesde: this.calcularFecha_desde(anioMaximo),
      fechaHasta: this.calcularFecha_hasta(anioMinimo),
    };
  }

  /**
   * Función para calcular la fecha inicial (desde) para utilizar el la selección del calendario en el campo fecha de nacimiento
   * @param anioMinimoDocumento años a restar a la fecha actual
   */
  private calcularFecha_desde(anioMinimoDocumento: number) {
    const diferenciaAnio = this.fechaActual.getFullYear() - anioMinimoDocumento;
    const mes = this.fechaActual.getMonth();
    let dia = this.fechaActual.getDate();

    // Se toma un dia antes en caso de que la fecha es bisiesto
    if (mes === 1 && dia === 29) {
      dia -= 1;
    }

    const date = new Date(diferenciaAnio, mes, dia);
    return date;
  }

  /**
   * Función para calcular la fecha final (hasta) para utilizar el la selección del calendario en el campo fecha de nacimiento
   * @param anioMaximoDocumento años a restar a la fecha actual
   */
  private calcularFecha_hasta(anioMaximoDocumento: number) {
    const diferenciaAnio = this.fechaActual.getFullYear() - anioMaximoDocumento;
    const mes = this.fechaActual.getMonth();
    let dia = this.fechaActual.getDate();

    // Se toma un dia despues en caso de que la fecha es bisiesto
    if (mes === 1 && dia === 29) {
      dia += 1;
    }

    const date = new Date(diferenciaAnio, mes, dia);
    return date;
  }

  private calcularFecha_desde2(anioMinimoDocumento: number) {
    const diferenciaAnio = this.fechaActual.getFullYear() - anioMinimoDocumento;
    const mes = this.fechaActual.getMonth();
    let dia = this.fechaActual.getDate()+1;

    // Se toma un dia antes en caso de que la fecha es bisiesto
    if (mes === 1 && dia === 29) {
      dia -= 1;
    }

    const date = new Date(diferenciaAnio, mes, dia);
    return date;
  }
}
